import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'
import MassMessageModal from "../Material/MassMessageModal"
import ListingFilters from '../Material/ListingFilters'
import toTitleCase from "../Functions/toTitleCase"
import { Row, Col, Input } from "reactstrap"
import { TagsQuery, RepsQuery, LeadStatus, LeadType } from "./Queries"
import BulkRepAssignment from "../Material/BulkRepAssignment"
import ConfirmationPopup from "../Material/ConfirmationPopup"
import { HasPermissionsQuery } from "../Functions/querys"
import getFilterValuesFromQueryString from "../Functions/getFilterValuesFromQueryString"
import updateFilters from "../Functions/updateFilters"
import handleConfigurationChange from "../Functions/handleConfigurationChange"
import TablePreferencePicker from "../Material/TablePreferencePicker"
import withApolloClient from "../withApolloClient"


const RepAssignment = gql`mutation BulkRepAssignment($input:BulkRepAssignmentMutationInput!){
    bulkRepAssignment(input:$input){
        errors{
            messages
        }
        ok
    }
}`
const BulkArchiveLead = gql`mutation  BulkArchiveLead($input:BulkArchiveLeadInput!){
    bulkArchiveLead(input:$input){
        errors{
            messages
        }
        ok
    }
}`
const AllBranchesQuery = gql`query AllBranchesQuery {
    optionsList: allBranches(isUserScoped:true) {
        edges {
            node {
                id
                name
            }
        }
    }
}`

class LeadsListHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            configurations: null,
            filterValues: this.props.filterValues,
            loading: false,
            error: "",
        }
    }

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    unAssignReps = () => {
        let input = {
            objectIds: this.props.selectedLeads.map(item => item.id),
        }

        this.props.apolloClient.mutate({
            mutation: RepAssignment,
            variables: { input }
        }).then((result) => {
            this.props.refetchQuery()
            this.props.handleClose()
        })
    }

    updateSearchTerm = (searchTerm) => {
        updateFilters({ ...this.props.filterValues, searchTerm }, this.state.configurations, this.props.navigate, this.props.location, this.props.setFilterValues)
    }

    handleBulkArchiveLeads = () => {
        this.setState({ loading: true })
        let input = {
            leadIds: this.props.selectedLeads.map(item => item.id),
        }

        this.props.apolloClient.mutate({
            mutation: BulkArchiveLead,
            variables: { input }
        }).then((result) => {
            if (result && result.data && result.data.bulkArchiveLead && result.data.bulkArchiveLead.ok) {
                this.props.refetchQuery()
                this.toggleModal("")
                this.setState({ input: {}, loading: false, error: null })
            } else if (result.data && result.data.bulkArchiveLead.errors && result.data.bulkArchiveLead.errors.length > 0) {
                this.setState({ loading: false, error: result.data.bulkArchiveLead.errors[0].messages[0] })
            }
        }).catch((err) => {
            this.setState({ loading: false, error: err })
        })
    }

    removeFilter = (filterName) => {
        let filterValues = this.props.filterValues
        let filterKeys = Object.keys(filterValues)
        if (filterKeys.includes(filterName)) {
            delete filterValues[filterName]
            updateFilters({ ...this.props.filterValues }, this.state.configurations, this.props.navigate, this.props.location, this.props.setFilterValues)
        }
    }

    getValueByFilterType = (filterConfigs, value) => {
        if (filterConfigs.type === "select") {
            let options = filterConfigs["options"]
            if (options && options.length > 0) {
                if (Array.isArray(value)) {
                    value = value.map(item => options.find(option => option.value === item).label)
                } else {
                    if (value === true) {
                        value = 'true'
                    }
                    else if (value === false) {
                        value = 'false'
                    }
                    value = options.find(option => option.value === value) && options.find(option => option.value === value).label
                }
            }
        } else if (filterConfigs.type === "boolean") {
            value = toTitleCase(value.toString())
        } else if (filterConfigs.type === "date-range")
            value = value[0].startDate && value[0].endDate ? value[0].startDate : ""
        return Array.isArray(value) ? value.join(", ") : value
    }

    getFilterConfigurations = (activeTab) => {
        return [
            {
                type: "select", name: "assignedTo", title: "Assigned Reps", valueSelector: "id", labelSelector: "username",
                optionsQuery: RepsQuery, variables: { groups: ["Sales Team"] }, placeholder: "Filter By Assigned Reps",
                showFilter: true
            },
            { type: "select", name: "driverTags", title: "Driver Tags", optionsQuery: TagsQuery, placeholder: "Filter By Driver Tags", valueSelector: "name", labelSelector: "name", isMulti: true, showFilter: true },
            { type: "select", name: "statuses", title: "Lead Status", optionsQuery: LeadStatus, placeholder: "Filter By Lead Status", valueSelector: "name", extractValue: true, labelSelector: "description", isMulti: true, showFilter: ["#all"].includes(activeTab) },
            { type: "select", name: "leadTypes", title: "Lead Type", optionsQuery: LeadType, placeholder: "Filter By Lead Type", valueSelector: "name", extractValue: true, labelSelector: "description", isMulti: true, showFilter: ["#all"].includes(activeTab) },
            { type: "boolean", name: "isArchived", title: "Filter By Archived Leads", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Archived Leads", showFilter: ["#all"].includes(activeTab) },
            { type: "boolean", name: "inOffice", title: "Filter By Driver In Office", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Driver In Office", showFilter: ["#all", "#didnttakecar", "#open"].includes(activeTab) },
            { type: "boolean", name: "isBlocked", title: "Filter By Is Blocked", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Is Blocked", showFilter: ["#all", "#didnttakecar", "#open", "#review"].includes(activeTab) },
            { type: "select", name: "selectedBranches", title: "Branches", optionsQuery: AllBranchesQuery, placeholder: "Filter By Branches", valueSelector: "id", labelSelector: "name", isMulti: true, showFilter: true },
        ]
    }
    setConfigurations = () => {
        let conf = this.getFilterConfigurations(this.props.activeTab)
        let configurations = conf.filter(filter => filter['showFilter']).map(filter => {
            if (filter['optionsQuery']) {
                let options = []
                this.props.apolloClient.query({
                    query: filter.optionsQuery,
                    variables: { ...filter.variables }
                }).then(result => {
                    if (result && result.data.optionsList && result.data.optionsList.edges && result.data.optionsList.edges.length > 0) {
                        options = result.data.optionsList.edges.map(options => options.node && ({
                            value: options.node[filter.valueSelector], label: options.node[filter.labelSelector]
                        }))
                    } else if (result && result.data.optionsList && result.data.optionsList.states && result.data.optionsList.states.length > 0) {
                        options = result.data.optionsList.states.map(options => options.node ? ({ value: options.node[filter.valueSelector], label: options.node[filter.labelSelector] }) : ({ value: filter.extractValue ? options[filter.valueSelector] : options[filter.valueSelector], label: options[filter.labelSelector] }))
                    }
                    filter['options'] = options
                    delete filter['optionsQuery']
                })
            }
            return filter
        })
        this.setState({ configurations: configurations })
    }
    componentDidMount() {
        if (this.props.activeTab)
            this.setConfigurations()

        const { apolloClient } = this.props
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.activeTab !== prevProps.activeTab) {
            this.setConfigurations()
        }

        if (this.state.configurations !== prevState.configurations) {
            let urlFilterValues = getFilterValuesFromQueryString(this.props.location.search, this.state.configurations)
            handleConfigurationChange(prevState.configurations, this.state.configurations, urlFilterValues, this.props.setFilterValues, this.props.navigate, this.props.location, this.props.defaultFilters, updateFilters)
        }
    }

    render() {
        return (
            <Row className="pb-2">
                {this.state.openModal === "viewFilters" &&
                    <ListingFilters open={this.state.openModal === "viewFilters"} handleClose={() => this.toggleModal("")}
                        target="viewFilters" filterValues={this.props.filterValues} setFilterValues={(filters => updateFilters(filters, this.state.configurations, this.props.navigate, this.props.location, this.props.setFilterValues))}
                        filters={this.state.configurations}
                    />}
                {this.state.openModal === "MassMessageModal" && <MassMessageModal handleClose={() => this.toggleModal("MassMessageModal")} open={this.state.openModal === "MassMessageModal"} drivers={this.props.selectedLeads && this.props.selectedLeads.length > 0 ? this.props.selectedLeads.map(item => item.customer.id) : null} />}
                {this.state.openModal === "BulkAssignmentModal" && <BulkRepAssignment
                    open={this.state.openModal === "BulkAssignmentModal"}
                    title={"Assign " + this.props.selectedLeads.length + " Selected Drivers to Reps"}
                    selectedObjectIds={this.props.selectedLeads.map(item => item.id)}
                    handleClose={() => this.toggleModal(false)}
                    refetchQuery={this.props.refetchQuery}
                    groups={["Sales Team"]}
                />}
                {this.state.openModal === "confirmation" && <ConfirmationPopup
                    open={this.state.openModal === "confirmation"}
                    message={"Unassign " + this.props.selectedLeads.length + " Selected Applications"}
                    handleClose={() => this.toggleModal("confirmation")}
                    action={"Yes"}
                    confirmAction={this.unAssignReps}
                    color="danger"
                />}
                {this.state.openModal === "BulkArchiveLead" && <ConfirmationPopup
                    open={this.state.openModal === "BulkArchiveLead"}
                    message={"Are you sure you want to archive " + this.props.selectedLeads.length + " selected leads?"}
                    handleClose={() => this.toggleModal("BulkArchiveLead")}
                    action={"Yes"}
                    confirmAction={this.handleBulkArchiveLeads}
                    color="danger"
                    loading={this.state.loading}
                    error={this.state.error ? this.state.error : ""}
                />}
                {this.state.openModal === "viewColumnPicker" &&
                    <TablePreferencePicker columnConfig={this.props.columnConfig} currentUser={this.props.currentUser} open={this.state.openModal === "viewColumnPicker"} target="toggleColumnPickerButton" setColumns={this.props.setColumns} refetchPreferences={this.props.refetchPreferences} preferenceType={this.props.preferenceType} />
                }
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} key={`searchTerm-${this.props.activeTab}`} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs={8} className="text-right mt-2">
                    {this.props.selectedLeads && this.props.selectedLeads.length > 0 && this.props.selectedLeads.filter(item => item.customer && item.customer.id).length > 0 && <><a className="driver-list-button" onClick={() => this.toggleModal("MassMessageModal")}>
                        Message Drivers | <i className="fa fa-commenting-o" aria-hidden="true"></i>
                    </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    {this.props.hasPermissions && this.props.hasPermissions.includes("delete_lead") && this.props.selectedLeads.length > 0 && <>
                        <a className="driver-list-button" onClick={() => this.toggleModal("BulkArchiveLead")}>
                            Bulk Archive | <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </>}
                    {this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_edit_lead_rep") && this.props.selectedLeads.length > 0 && <>
                        <a className="driver-list-button" onClick={() => this.toggleModal("confirmation")}>
                            Unassign Rep | <i className="fa fa-minus" aria-hidden="true"></i>
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;
                        <a className="driver-list-button" onClick={() => this.toggleModal("BulkAssignmentModal")}>
                            Assign Rep | <i className="fa fa-plus" aria-hidden="true"></i>
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;
                    </>}
                    <a id="toggleColumnPickerButton" className="driver-list-button" onClick={() => this.toggleModal("viewColumnPicker")}>
                        Preference | <i className="fa fa-table" aria-hidden="true"></i>
                    </a>&nbsp;&nbsp;&nbsp;&nbsp;
                    <a id="viewFilters" className="driver-list-button" onClick={() => this.toggleModal("viewFilters")}>
                        Apply Filters | <i className="fa fa-filter" aria-hidden="true"></i> {this.props.filterValues && Object.keys(this.props.filterValues).filter(key => this.props.filterValues[key] !== null && this.state.configurations && this.state.configurations.find(setting => setting.name === key) && this.state.configurations.find(setting => setting.name === key).showFilter).length || ""}
                    </a>

                </Col>
                <Col xs={12} className="mt-2">
                    {Object.keys(this.props.filterValues).filter(key => this.props.filterValues[key] !== null && this.state.configurations && this.state.configurations.find(setting => setting.name === key) && this.state.configurations.find(setting => setting.name === key).showFilter).map(key =>
                        <span className="search-filter-preview">
                            <span>
                                <i className="fa fa-times-circle" onClick={() => this.removeFilter(this.state.configurations.find(setting => setting.name === key).name)}></i>&nbsp;&nbsp;
                                {this.state.configurations.find(setting => setting.name === key).title}
                            </span>
                            {this.getValueByFilterType(this.state.configurations.find(setting => setting.name === key), this.props.filterValues[key])}
                        </span>
                    )}
                    {this.props.selectedLeads && this.props.selectedLeads.length > 0 && <span className="search-filter-preview">
                        <span> <i className="fa fa-times-circle" onClick={this.props.resetSelectedLeads}></i> &nbsp;&nbsp; Selected Leads</span>
                        {this.props.selectedLeads.length}
                    </span>}
                </Col>
            </Row >
        )
    }
}


//-----------------------------------
export default graphql(HasPermissionsQuery, {
    options: () => ({ variables: { userPermissions: ["custom_can_edit_lead_rep", "delete_lead"] }, fetchPolicy: "network-only", notifyOnNetworkStatusChange: true }),
    props: ({ data: { hasPermissions, loading, variables } }) => ({
        hasPermissions, loading, variables
    })
})(withApolloClient(LeadsListHeader))
